/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";

import type { FC, SVGAttributes } from "react";

type Props = SVGAttributes<SVGElement>;

export const ArrowDownIcon: FC<Props> = (props) => (
  <svg viewBox="0 0 11 7" fill="none" {...props}>
    <path
      d="M5.30333 4.125L9.42833 0L10.6067 1.17833L5.30333 6.48167L0 1.17833L1.17833 0L5.30333 4.125Z"
      fill="currentColor"
    />
  </svg>
);
